import { render } from "./RentalCoupon.vue?vue&type=template&id=b2692532&scoped=true"
import script from "./RentalCoupon.vue?vue&type=script&lang=js"
export * from "./RentalCoupon.vue?vue&type=script&lang=js"

import "./RentalCoupon.vue?vue&type=style&index=0&id=b2692532&lang=scss&scoped=true"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2692532"]])

export default __exports__